const passengers = {
  table: {
    headers: {
      supplier: 'Flotte',
    }
  },
  forms: {
    information: {
      supplier: {
        header: 'Flotte',
        fields: {
          label: 'Bevorzugte Flotte',
        },
      },
    },
  },
};

export default passengers;
